import React from 'react';
import { HeroVariant30 } from '../components/HeroVariant30';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { FAQ } from '../components/FAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { CookieBanner } from '../components/CookieBanner';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { FloatingContact } from '../components/FloatingContact';
export function LandingPage30() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-1585">
      <Navigation data-id="element-1586" />
      <main data-id="element-1587">
        <HeroVariant30 data-id="element-1588" />
        <WhyUs data-id="element-1589" />
        <Services data-id="element-1590" />
        <FAQ data-id="element-1591" />
        <Testimonials data-id="element-1592" />
        <Consultation data-id="element-1593" />
      </main>
      <Footer data-id="element-1594" />
      <CookieBanner data-id="element-1595" />
      <FloatingContact data-id="element-1596" />
    </div>;
}